import { VETLINES_PRODUCTS } from "../../constants";

export default function VetlinesProducts() {
    return (
        <div className="sm:py-12 py-6 border-b border-neutral-300 sm:px-16 px-6">
            <h3 className="text-emerald-500 font-poppins font-semibold text-center md:text-[30px] xs:text-[25px] text-[20px]">
                VETLINES Products
            </h3>

            <div className="grid md:grid-cols-2 gap-6 mt-8">
                {VETLINES_PRODUCTS.map((product) => (
                    <div
                        key={product.id}
                        className="border border-neutral-200 rounded-2xl overflow-hidden flex flex-col bg-white hover:shadow-md transition"
                    >
                        <img
                            src={product.image}
                            alt={product.name}
                            className="w-full h-[260px] object-contain bg-neutral-50 p-4"
                        />
                        <div className="p-5 flex-1 flex flex-col">
                            <h4 className="font-poppins font-bold text-lg text-emerald-700">
                                {product.name}
                            </h4>
                            <p className="text-sm text-neutral-600 mt-2">
                                {product.description}
                            </p>

                            <p className="text-sm font-semibold text-neutral-800 mt-4">
                                Indications:
                            </p>
                            <ul className="mt-1 space-y-1">
                                {product.indications.map((indication) => (
                                    <li
                                        key={indication}
                                        className="text-sm text-neutral-700 flex gap-2"
                                    >
                                        <span aria-hidden="true">✅</span>
                                        <span>{indication}</span>
                                    </li>
                                ))}
                            </ul>

                            <p className="text-xs mt-4 bg-green-100 text-emerald-800 rounded-md px-2 py-1 self-start">
                                💧 Dosage: {product.dosage}
                            </p>
                            <p className="text-sm text-neutral-700 mt-3">
                                {product.packs}
                            </p>
                            <p className="text-sm font-poppins font-semibold text-emerald-600 mt-auto pt-4">
                                {product.tagline}
                            </p>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}